import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Card, Col, Row, Spinner, Button, ProgressBar } from "react-bootstrap";
import Filtros from "./components/Filtros";
import { ReporteEstadiaService } from "../../../services/apiService";
import MasterDetailTable from "./components/estadias-lista-quro/MasterDetailTable";
import EstadiasUbicacionesFrec from "./components/estadias-ubicaciones-frecuentes/EstadiasUbicacionesFrec";
import EstadiasTiempoUbi from "./components/estadias-tiempo-ubicaciones/EstadiasTiempoUbi";
import EstadiasTotal from "./components/estadias-total/EstadiasTotal";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";
import { groupBy, sortBy } from "underscore";
import { segundosATiempo } from "../../../helpers/utils";
import { useEstadiasStore } from "../../../lib/store/estadias.store";
import { paginadoRecorridosStore } from "../../../lib/store/paginador_store";
//import { asignarVelocidadMaxima, calcularEstadiasMultiples, calcularResumenUnidad, procesarRecorridos } from "../../../utils/useReporteCalculations";
import {
  calcularResumenUnidad,
  calcularEstadiasMultiples,
  procesarRecorridos,
  asignarVelocidadMaxima,
  normalizarFiltros, // ✅ IMPORTAR NUEVA FUNCIÓN
} from "../../../utils/useReporteCalculations";

import cargarPaginas, {
  cargarPaginasConMetricas,
  cargarPaginasUltraOptimizado,
} from "../../../providers/provider_paginado";
import classNames from "classnames";
import { jwtDecode } from "jwt-decode";
import { limpiarCache } from "../../../providers/provider_paginado";
import PrintReportModule from "../../../components/print/PrintReportModule";
import {
  LoadingEmptyState,
  NoDataEmptyState,
  NoSelectionEmptyState,
  WelcomeEmptyState,
} from "../../../components/common/EmptyState";
import StandardProgressBar from '../../../components/common/ProgressBar/StandardProgressBar';

// ✅ COMPONENTE DE ESTADO VACÍO
const EmptyState = ({ icon, title, message, isLoading }) => (
  <Card className="mt-3 text-center py-5">
    <Card.Body
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "40vh" }}
    >
      {isLoading ? (
        <>
          <Spinner
            animation="border"
            variant="primary"
            style={{ width: "4rem", height: "4rem", marginBottom: "1.5rem" }}
          />
          <h4 className="text-primary mb-3">Cargando datos...</h4>
          <p className="text-muted mb-0 w-75">
            Estamos procesando tu solicitud, esto puede tomar unos momentos.
          </p>
        </>
      ) : (
        <>
          <div className="mb-3 text-muted" style={{ fontSize: "4rem" }}>
            {icon || <i className="far fa-calendar-alt"></i>}
          </div>
          <h4 className="mb-3">{title}</h4>
          <p className="text-muted mb-0 w-75">{message}</p>
        </>
      )}
    </Card.Body>
  </Card>
);

// ✅ COMPONENTE DE PROGRESO MEJORADO
const ProgressBarWithComponents = ({
  loadingComponents,
  calculateTotalProgress,
  debugMetrics,
}) => {
  const componentColors = {
    recorridos: "#2E7D32",
    estadias: "#1976D2",
    graficos: "#D32F2F",
    ubicaciones: "#7B1FA2",
    resumen: "#F57C00",
  };

  const activeComponents = Object.entries(loadingComponents)
    .filter(([_, state]) => state.loading || state.complete)
    .map(([component, state]) => ({
      component,
      color: componentColors[component],
      progress: state.progress,
      isComplete: state.complete,
    }));

  if (activeComponents.length === 0) return null;

  const totalProgress = calculateTotalProgress();

  return (
    <>
      <Row>
        <Col md={12}>
          <StandardProgressBar
            calculateTotalProgress={calculateTotalProgress}
            debugMetrics={debugMetrics}
          />
        </Col>
      </Row>
      {/* <div className="d-flex justify-content-between small mb-1">
        <span>Generando reporte: {totalProgress.toFixed(0)}%</span>
        <span className="text-muted">
          {Object.values(loadingComponents).filter((c) => c.complete).length}/
          {Object.keys(loadingComponents).length} componentes listos
        </span>
      </div>

      <ProgressBar style={{ height: 12 }} className="shadow-none rounded-4">
        {activeComponents.map(({ component, color, progress, isComplete }) => (
          <ProgressBar
            key={component}
            style={{ backgroundColor: color }}
            now={progress * (1 / activeComponents.length)}
            animated={!isComplete}
            className="position-relative"
          />
        ))}
      </ProgressBar>

      <div className="d-flex justify-content-between mt-1 small text-muted">
        {activeComponents.map(({ component, color, isComplete }) => (
          <div key={component} className="d-flex align-items-center">
            <span
              className="dot mr-1"
              style={{
                backgroundColor: color,
                width: 8,
                height: 8,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: 5,
              }}
            />
            <span>
              {component.charAt(0).toUpperCase() + component.slice(1)}
              {isComplete && (
                <i className="fas fa-check-circle ml-1 text-success" />
              )}
            </span>
          </div>
        ))}
      </div> */}
    </>
  );
};

export default function EstadiasReport() {
  const paginadorRecorridos = paginadoRecorridosStore();
  const [recorridos, setRecorridos] = useState([]);
  const [totalCarga, setTotalCarga] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [estadias, setEstadias] = useState([]);
  const [resumenUnidad, setResumenUnidad] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInitiated, setSearchInitiated] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [geocercas, setGeocercas] = useState([]);
  const [referencias, setReferencias] = useState([]);
  const [clientes, setClientes] = useState([]);

  const [filters, setFilters] = useState({
    fecha_inicio: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
    fecha_fin: new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
    uids_vehiculo: [],
    tipo_vista: 0,
    tipo_reporte: 0,
    tiempo_estancia: 0,
    distancia_estancia: 0,
    encendido_o_apagado: "Todo",
  });
  const [selectedVehiclesDetail, setSelectedVehiclesDetail] = useState([]);

  // ✅ ESTADOS DE COMPONENTES DE CARGA
  const [loadingComponentsEstandard, setLoadingComponentsEstandard] = useState({
    table: { loading: false, progress: 0, complete: false },
    vehicles: { loading: false, progress: 0, complete: false }
  });


  const calculateTotalProgressEstandard = useCallback(() => {
    const weights = {
      table: 0.2,      // ✅ Ajustar para que sume 100%
      vehicles: 0.8,   // ✅ Solo componentes que existen              
    };

    let totalProgress = 0;
    let totalWeight = 0;

    Object.entries(loadingComponentsEstandard).forEach(([component, state]) => {
      if (state && (state.loading || state.complete)) {
        const progress = Number(state.progress);
        if (!isNaN(progress)) {
          totalProgress += progress * weights[component];
          totalWeight += weights[component];
        } else {
          totalProgress += (state.complete ? 100 : 0) * weights[component];
          totalWeight += weights[component];
        }
      }
    });

    if (totalWeight === 0) return 0;
    const result = totalProgress / totalWeight;

    return Math.min(Math.max(result, 0), 100);
  }, [loadingComponentsEstandard]);

  const [debugMetricsEstandard, setDebugMetricsEstandard] = useState({
    searchStartTime: null,
    searchEndTime: null,

    connections: {
      'ListTable': {
        name: 'Estadias (GPS)',
        startTime: null,
        endTime: null,
        totalRecordsExpected: 0,
        totalRecordsReceived: 0,
        totalApiCalls: 0,
        completedApiCalls: 0,
        failedApiCalls: 0,
        recoveredApiCalls: 0,
        apiCallsHistory: [],
        downloadProgress: 0,
        status: 'pending'
      }
    },

    globalTotalRecordsExpected: 0,
    globalTotalRecordsReceived: 0,
    globalDownloadProgress: 0,
    activeConnections: 0,

    componentTimes: {
      table: { start: null, end: null },
      vehicles: { start: null, end: null }
    }
  });

  const updateComponentProgressEstandard = useCallback((component, progress, isComplete = false) => {
    setLoadingComponentsEstandard(prevState => {
      const newState = { ...prevState };

      if (newState[component]) {
        newState[component] = {
          ...newState[component],
          loading: !isComplete,
          progress: isComplete ? 100 : Math.max(0, Math.min(100, progress)),
          complete: isComplete
        };
      }

      return newState;
    });

    // ✅ Actualizar métricas directamente sin dependencia circular
    setDebugMetricsEstandard(prev => ({
      ...prev,
      componentTimes: {
        ...prev.componentTimes,
        [component]: {
          start: !isComplete ? Date.now() : (prev.componentTimes[component]?.start || Date.now()),
          end: isComplete ? Date.now() : null
        }
      }
    }));
  }, []);

  const logRecorridoSnapshot = useCallback((label, dataset) => {
    if (!dataset || dataset.length === 0) {
      console.warn(`[EstadiasReport] ${label}: dataset vacío`);
      return;
    }

    const sample = dataset.slice(0, 3).map((item, index) => ({
      index,
      vehiculoUid: item.vehiculoUid || item.vehiculos?.vehiculoUid,
      fecha: item.fecha || item.fechaCorta || item.fecha_inicio,
      tipo: item.tipo,
      tipoMotor: item.tipoMotor ?? item.tipo_motor,
      nombreEvento: item.nombreEvento,
      velocidad: item.velocidad,
      latitud: item.latitud,
      longitud: item.longitud
    }));

    console.log(`[EstadiasReport] ${label}:`, {
      total: dataset.length,
      sample
    });
  }, []);

  const updateDebugMetricsEstandard = useCallback((updates) => {
    setDebugMetricsEstandard(prev => {
      if (!prev || !prev.connections) {
        console.warn('⚠️ debugMetrics no está inicializado correctamente');
        return prev || {
          connections: {},
          globalTotalRecordsExpected: 0,
          globalTotalRecordsReceived: 0,
          globalDownloadProgress: 0,
          activeConnections: 0,
          componentTimes: {}
        };
      }
      const newState = { ...prev };

      if (updates.connectionId && newState.connections[updates.connectionId]) {
        const connection = newState.connections[updates.connectionId];

        if (!connection.apiCallsHistory) {
          connection.apiCallsHistory = [];
        }

        // Actualizar datos específicos de la conexión
        Object.keys(updates).forEach(key => {
          if (key !== 'connectionId') {
            if (key === 'apiCallsHistory' && Array.isArray(updates[key])) {
              const newCalls = updates[key].map(call => ({
                ...call,
                timestamp: call.timestamp || Date.now()
              }));
              connection[key] = [...(connection[key] || []), ...newCalls];

              if (connection[key].length > 50) {
                connection[key] = connection[key].slice(-50);
              }
            } else if (key !== 'apiCallsHistory') {
              connection[key] = updates[key];
            }
          }
        });

        const activeConnections = Object.values(newState.connections).filter(conn =>
          conn && (conn.status === 'downloading' || conn.status === 'completed')
        );

        newState.globalTotalRecordsExpected = activeConnections.reduce((sum, conn) =>
          sum + (conn.totalRecordsExpected || 0), 0
        );

        newState.globalTotalRecordsReceived = activeConnections.reduce((sum, conn) =>
          sum + (conn.totalRecordsReceived || 0), 0
        );

        newState.globalDownloadProgress = newState.globalTotalRecordsExpected > 0 ?
          (newState.globalTotalRecordsReceived / newState.globalTotalRecordsExpected * 100) : 0;

        newState.activeConnections = activeConnections.length;

      } else if (updates.connectionId && !newState.connections[updates.connectionId]) {
        newState.connections[updates.connectionId] = {
          name: updates.connectionId,
          startTime: null,
          endTime: null,
          totalRecordsExpected: 0,
          totalRecordsReceived: 0,
          totalApiCalls: 0,
          completedApiCalls: 0,
          failedApiCalls: 0,
          recoveredApiCalls: 0,
          apiCallsHistory: [],
          downloadProgress: 0,
          status: 'pending'
        };

        Object.keys(updates).forEach(key => {
          if (key !== 'connectionId') {
            newState.connections[updates.connectionId][key] = updates[key];
          }
        });

      } else {
        Object.keys(updates).forEach(key => {
          if (key === 'componentTimes') {
            if (!newState.componentTimes) {
              newState.componentTimes = {};
            }
            newState.componentTimes = { ...newState.componentTimes, ...updates.componentTimes };
          } else if (key !== 'connectionId') {
            newState[key] = updates[key];
          }
        });
      }

      return newState;
    });

    // ✅ SINCRONIZAR DESCARGA CON BARRA DE PROGRESO
    if (updates.connectionId && updates.downloadProgress !== undefined) {
      setTimeout(() => {
        const componentMapping = {
          'ListTable': 'list'
        };

        const componentName = componentMapping[updates.connectionId];

        if (componentName) {
          // ✅ Usar el progreso real de descarga para actualizar el componente
          const isComplete = updates.downloadProgress >= 100;
          const progressValue = Math.round(updates.downloadProgress || 0);

          console.log(`🔄 [Sincronización] ${componentName}: ${progressValue}% (descarga ${isComplete ? 'completa' : 'en progreso'})`);

          updateComponentProgressEstandard(componentName, progressValue, isComplete);

          // ✅ Si la descarga está completa, también marcar como cargando = false
          if (isComplete) {
            setLoadingComponentsEstandard(prevState => ({
              ...prevState,
              [componentName]: {
                loading: false,
                progress: 100,
                complete: true
              }
            }));
          }
        }
      }, 0);
    }
  }, [updateComponentProgressEstandard]);
  /*
    // ✅ ESTADO DE DEBUG METRICS
    const [loadingComponents, setLoadingComponents] = useState({
      recorridos: { loading: false, progress: 0, complete: false },
      estadias: { loading: false, progress: 0, complete: false },
      graficos: { loading: false, progress: 0, complete: false },
      ubicaciones: { loading: false, progress: 0, complete: false },
      resumen: { loading: false, progress: 0, complete: false },
    });
  
    const [debugMetrics, setDebugMetrics] = useState({
      searchStartTime: null,
      searchEndTime: null,
      connections: {
        "recorridos-vehiculos": {
          name: "Datos de Recorridos",
          startTime: null,
          endTime: null,
          totalRecordsExpected: 0,
          totalRecordsReceived: 0,
          totalApiCalls: 0,
          completedApiCalls: 0,
          failedApiCalls: 0,
          recoveredApiCalls: 0,
          apiCallsHistory: [],
          downloadProgress: 0,
          status: "pending",
        },
      },
      globalTotalRecordsExpected: 0,
      globalTotalRecordsReceived: 0,
      globalDownloadProgress: 0,
      activeConnections: 0,
      componentTimes: {
        recorridos: { start: null, end: null },
        estadias: { start: null, end: null },
        graficos: { start: null, end: null },
        ubicaciones: { start: null, end: null },
        resumen: { start: null, end: null },
      },
    });
  */
  const [showDebugPanel, setShowDebugPanel] = useState(false);

  // ✅ REFS PARA CONTROL
  const safetyTimeoutRef = useRef(null);
  const monitorIntervalRef = useRef(null);
  const isLoadingRef = useRef(false); // ✅ NUEVO REF PARA PREVENIR CICLOS

  // STORES DE ESTADIAS
  const setDataEstadias = useEstadiasStore((state) => state.setDataEstadias);
  const setFiltroEstadiaTiempo = useEstadiasStore(
    (state) => state.setFiltroEstadiaTiempo
  );
  const setFiltroEstadiaUbicacion = useEstadiasStore(
    (state) => state.setFiltroEstadiaUbicacion
  );

  // ESTADOS PARA RESALTAR Y FILTRAR
  const [highlightedAlertType, setHighlightedAlertType] = useState(null);
  const [selectedAlertType, setSelectedAlertType] = useState(null);
  /*
    // ✅ FUNCIÓN PARA ACTUALIZAR MÉTRICAS DE DEBUG - OPTIMIZADA
    const updateDebugMetrics = useCallback((updates) => {
      setDebugMetrics((prev) => {
        if (!prev || !prev.connections) {
          return (
            prev || {
              connections: {},
              globalTotalRecordsExpected: 0,
              globalTotalRecordsReceived: 0,
              globalDownloadProgress: 0,
              activeConnections: 0,
              componentTimes: {},
            }
          );
        }
  
        const newState = { ...prev };
  
        if (updates.connectionId && newState.connections[updates.connectionId]) {
          const connection = newState.connections[updates.connectionId];
  
          if (!connection.apiCallsHistory) {
            connection.apiCallsHistory = [];
          }
  
          Object.keys(updates).forEach((key) => {
            if (key !== "connectionId") {
              if (key === "apiCallsHistory" && Array.isArray(updates[key])) {
                const newCalls = updates[key].map((call) => ({
                  ...call,
                  timestamp: call.timestamp || Date.now(),
                }));
                connection[key] = [...(connection[key] || []), ...newCalls];
  
                if (connection[key].length > 50) {
                  connection[key] = connection[key].slice(-50);
                }
              } else if (key !== "apiCallsHistory") {
                connection[key] = updates[key];
              }
            }
          });
  
          const activeConnections = Object.values(newState.connections).filter(
            (conn) =>
              conn &&
              (conn.status === "downloading" || conn.status === "completed")
          );
  
          newState.globalTotalRecordsExpected = activeConnections.reduce(
            (sum, conn) => sum + (conn.totalRecordsExpected || 0),
            0
          );
  
          newState.globalTotalRecordsReceived = activeConnections.reduce(
            (sum, conn) => sum + (conn.totalRecordsReceived || 0),
            0
          );
  
          newState.globalDownloadProgress =
            newState.globalTotalRecordsExpected > 0
              ? (newState.globalTotalRecordsReceived /
                newState.globalTotalRecordsExpected) *
              100
              : 0;
  
          newState.activeConnections = activeConnections.length;
        } else if (
          updates.connectionId &&
          !newState.connections[updates.connectionId]
        ) {
          newState.connections[updates.connectionId] = {
            name: updates.connectionId,
            startTime: null,
            endTime: null,
            totalRecordsExpected: 0,
            totalRecordsReceived: 0,
            totalApiCalls: 0,
            completedApiCalls: 0,
            failedApiCalls: 0,
            recoveredApiCalls: 0,
            apiCallsHistory: [],
            downloadProgress: 0,
            status: "pending",
          };
  
          Object.keys(updates).forEach((key) => {
            if (key !== "connectionId") {
              newState.connections[updates.connectionId][key] = updates[key];
            }
          });
        } else {
          Object.keys(updates).forEach((key) => {
            if (key === "componentTimes") {
              if (!newState.componentTimes) {
                newState.componentTimes = {};
              }
              newState.componentTimes = {
                ...newState.componentTimes,
                ...updates.componentTimes,
              };
            } else if (key !== "connectionId") {
              newState[key] = updates[key];
            }
          });
        }
  
        return newState;
      });
    }, []);
  
    // ✅ FUNCIÓN PARA ACTUALIZAR PROGRESO DE COMPONENTES - OPTIMIZADA
    const updateComponentProgress = useCallback(
      (component, progress, isComplete = false) => {
        if (!component || typeof component !== "string") {
          console.error("Componente inválido:", component);
          return;
        }
  
        setLoadingComponents((prevState) => {
          if (prevState[component]?.complete && isComplete) {
            return prevState;
          }
  
          const newState = { ...prevState };
          newState[component] = {
            loading: !isComplete,
            progress: progress || 0,
            complete: isComplete,
          };
  
          console.log(
            `🔄 Actualizando estado de ${component}: ${progress}% ${isComplete ? "✓" : "..."
            }`
          );
          return newState;
        });
      },
      []
    );
  
    // ✅ FUNCIÓN PARA CALCULAR PROGRESO TOTAL
    const calculateTotalProgress = useCallback(() => {
      const weights = {
        recorridos: 0.4,
        estadias: 0.25,
        graficos: 0.15,
        ubicaciones: 0.15,
        resumen: 0.05,
      };
  
      let totalProgress = 0;
      let totalWeight = 0;
  
      Object.entries(loadingComponents).forEach(([component, state]) => {
        if (state && (state.loading || state.complete)) {
          const progress = Number(state.progress);
          if (!isNaN(progress)) {
            totalProgress += progress * weights[component];
            totalWeight += weights[component];
          } else {
            totalProgress += (state.complete ? 100 : 0) * weights[component];
            totalWeight += weights[component];
          }
        }
      });
  
      if (totalWeight === 0) return 0;
      const result = totalProgress / totalWeight;
      return Math.min(Math.max(result, 0), 100);
    }, [loadingComponents]);
  */
  // ✅ FUNCIÓN PARA LIMPIAR FILTROS - SIN DEPENDENCIAS PROBLEMÁTICAS
  const handleClearFilters = useCallback(() => {
    setSelectedAlertType(null);
    setHighlightedAlertType(null);
    setFiltroEstadiaTiempo({});
    setFiltroEstadiaUbicacion({});
  }, []);

  // ✅ FUNCIÓN PRINCIPAL OPTIMIZADA
  // const handleGenerateReport = useCallback((selectedFilters) => {
  //   // ✅ PREVENIR MÚLTIPLES EJECUCIONES
  //   if (isLoadingRef.current) {
  //     console.log("⚠️ Cancelando nueva búsqueda, ya hay una en progreso");
  //     return;
  //   }

  //   console.log("🧹 Limpieza completa antes de nueva búsqueda de estadías");

  //   const searchStartTime = Date.now();
  //   updateDebugMetrics({
  //     searchStartTime,
  //     searchEndTime: null,
  //     connections: {
  //       'recorridos-vehiculos': {
  //         name: 'Datos de Recorridos',
  //         startTime: null,
  //         endTime: null,
  //         totalRecordsExpected: 0,
  //         totalRecordsReceived: 0,
  //         totalApiCalls: 0,
  //         completedApiCalls: 0,
  //         failedApiCalls: 0,
  //         recoveredApiCalls: 0,
  //         apiCallsHistory: [],
  //         downloadProgress: 0,
  //         status: 'pending'
  //       }
  //     }
  //   });

  //   // Cancelar timeout de seguridad
  //   if (safetyTimeoutRef.current) {
  //     clearTimeout(safetyTimeoutRef.current);
  //     safetyTimeoutRef.current = null;
  //   }

  //   // Limpiar caché del paginador
  //   console.log("🧹 Limpiando caché del paginador de estadías");
  //   limpiarCache();

  //   // Reiniciar paginador
  //   paginadorRecorridos.reiniciar();

  //   // Reiniciar estados
  //   setTotalCarga([]);

  //   // Reiniciar progreso de componentes
  //   Object.keys(loadingComponents).forEach(component => {
  //     updateComponentProgress(component, 0, false);
  //   });

  //   // Reiniciar datos
  //   setRecorridos([]);
  //   setEstadias([]);
  //   setResumenUnidad([]);

  //   // Reiniciar filtros
  //   setSelectedAlertType(null);
  //   setHighlightedAlertType(null);
  //   setErrorMessage(null);

  //   // Limpiar intervalos
  //   if (monitorIntervalRef.current) {
  //     clearInterval(monitorIntervalRef.current);
  //     monitorIntervalRef.current = null;
  //   }

  //   console.log("✅ Limpieza completada, iniciando nueva búsqueda de estadías");
  //   setSearchInitiated(true);
  //   setFilters(selectedFilters);
  //   setShowFilters(true);
  // }, []); // ✅ SIN DEPENDENCIAS PROBLEMÁTICAS

  const handleGenerateReport = useCallback((selectedFilters) => {
    if (isLoadingRef.current) {
      console.log("⚠️ Cancelando nueva búsqueda, ya hay una en progreso");
      return;
    }

    console.log("🧹 Limpieza completa antes de nueva búsqueda de estadías");
    setEstadias([]);
    // Quita geocercas, clientes y referencias del objeto
    const { geocercas, clientes, referencias, ...restoFiltros } =
      selectedFilters;
    console.log(selectedFilters);
    // Asigna a los estados correspondientes
    setGeocercas(geocercas);
    setClientes(clientes);
    setReferencias(referencias);

    // Guarda solo los demás filtros (sin geocercas, clientes ni referencias)
    setFilters(restoFiltros);

    // ✅ NORMALIZAR FILTROS
    const filtrosNormalizados = normalizarFiltros(selectedFilters);
    filtrosNormalizados.vehiculos_detalle = selectedFilters.vehiculos_detalle || [];
    setSelectedVehiclesDetail(selectedFilters.vehiculos_detalle || []);

    // Resto del código de limpieza...

    console.log("✅ Limpieza completada, iniciando nueva búsqueda de estadías");
    setSearchInitiated(true);
    setFilters(filtrosNormalizados);
    setShowFilters(true);
  }, []);

  // COLORES PARA GRUPOS
  const groupColorsRef = useRef(new Map());
  const usedColors = new Set();

  const getUniqueColor = () => {
    let newColor;
    do {
      newColor = `#${Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, "0")}`;
    } while (usedColors.has(newColor));
    usedColors.add(newColor);
    return newColor;
  };

  const getGroupColor = (groupName) => {
    if (!groupColorsRef.current.has(groupName)) {
      const newColor = getUniqueColor();
      groupColorsRef.current.set(groupName, newColor);
    }
    return groupColorsRef.current.get(groupName);
  };

  // ✅ EFECTO PRINCIPAL SIMPLIFICADO Y OPTIMIZADO
  useEffect(() => {
    // ✅ PREVENIR EJECUCIONES MÚLTIPLES
    if (isLoadingRef.current) {
      console.log("⚠️ Carga ya en progreso, cancelando duplicado");
      return;
    }

    if (!filters || !searchInitiated || !filters.uids_vehiculo?.length) {
      return;
    }

    const loadEstadiasReport = async () => {
      // isLoadingRef.current = true; // ✅ MARCAR COMO CARGANDO

      // try {
      //   handleClearFilters();
      //   setErrorMessage(null);

      //   console.log("🚀 Iniciando carga de estadías con métricas");

      //   if (!paginadorRecorridos.cargando) {
      //     updateComponentProgress('recorridos', 5, false);

      //     const filtrosFormateados = {
      //       ...filters,
      //       uids_vehiculo: filters.uids_vehiculo || filters.uids_vehiculos
      //     };
      isLoadingRef.current = true;

      try {
        // updateComponentProgressEstandard('table', 5, false);

        handleClearFilters();
        setErrorMessage(null);

        console.log("🚀 Iniciando carga de estadías con métricas");

        if (!paginadorRecorridos.cargando) {

          // ✅ ESTABLECER TIEMPO DE INICIO SI NO ESTÁ YA ESTABLECIDO
          setDebugMetricsEstandard(prev => ({
            ...prev,
            searchStartTime: prev.searchStartTime || Date.now(),
            searchEndTime: null
          }));

          // ✅ MARCAR COMPONENTE COMO CARGANDO AL INICIAR DESCARGA
          setLoadingComponentsEstandard(prevState => ({
            ...prevState,
            table: { loading: true, progress: 0, complete: false },
            vehicles: { loading: true, progress: 0, complete: false }
          }));

          // updateComponentProgress("recorridos", 5, false);

          //updateComponentProgressEstandard('table', 10, false);

          // ✅ USAR FILTROS NORMALIZADOS
          const filtrosFormateados = normalizarFiltros(filters);

          console.log("[EstadiasReport] Filtros normalizados para carga:", filtrosFormateados);

          //updateComponentProgressEstandard('table', 25, false);

          let connectionId = "recorridos-vehiculos";
          /*
          const onPartialData = (data, progress, error) => {
            if (error) {
              console.error("❌ Error en carga de recorridos:", error);
              setErrorMessage(error);
              // updateComponentProgress("recorridos", 100, true);
              updateComponentProgressEstandard('vehicles', 100, true);
            } else {
              // updateComponentProgress(
              //   "recorridos",
              //   Math.min(progress * 0.8, 80),
              //   false
              // );

              updateComponentProgressEstandard('vehicles', Math.min(progress * 0.8, 80), false);

              if (progress === 100 || (!data.length && progress === 0)) {
                // updateComponentProgress("recorridos", 100, true);
                updateComponentProgressEstandard('vehicles', 100, true);
                console.log("✅ Recorridos cargados completamente");
              }
            }
          };

          const onMetricsUpdate = (metrics) => {
            updateDebugMetricsEstandard({
              connectionId: "recorridos-vehiculos",
              name: "Datos de Recorridos",
              status: "downloading",
              startTime: Date.now(),
              ...metrics,
            });
          };
          */
          await cargarPaginasConMetricas(
            process.env.REACT_APP_VEHICLE_LOCATIONS_URL,
            paginadorRecorridos,
            filtrosFormateados,
            connectionId,
            null,
            (updates) => {
              updateDebugMetricsEstandard({ ...updates, connectionId });

              if (updates.downloadProgress) {
                updateComponentProgressEstandard('vehicles', updates.downloadProgress * 0.8, false);
              }
            }
          );

          console.log("[EstadiasReport] Datos recibidos tras cargar páginas:", {
            totalRegistros: paginadorRecorridos.datos?.length || 0,
            cargaCompletada: paginadorRecorridos.cargaCompletada,
            paginadoCargando: paginadorRecorridos.cargando
          });
          updateDebugMetricsEstandard({
            connectionId: "recorridos-vehiculos",
            status: "completed",
            endTime: Date.now(),
          });
        }
      } catch (error) {
        console.error("Error al cargar reporte estadías:", error);
        setErrorMessage(`Error al cargar estadías: ${error.message}`);

        updateDebugMetricsEstandard({
          connectionId: "recorridos-vehiculos",
          status: "failed",
          endTime: Date.now(),
        });

        // updateComponentProgress("recorridos", 100, true);
        updateComponentProgressEstandard('vehicles', 100, true);
      } finally {
        setIsLoading(false);
        isLoadingRef.current = false; // ✅ MARCAR COMO COMPLETADO

        updateDebugMetricsEstandard({
          searchEndTime: Date.now(),
        });
      }
    };

    loadEstadiasReport();
  }, [filters, searchInitiated]); // ✅ DEPENDENCIAS MÍNIMAS Y ESTABLES

  // ✅ EFECTO SEPARADO PARA PROCESAR RECORRIDOS - EVITAR CICLOS
  useEffect(() => {
    if (!paginadorRecorridos.datos || paginadorRecorridos.datos.length === 0) {
      if (paginadorRecorridos.cargaCompletada === true && paginadorRecorridos.cargando === false) {
        updateComponentProgressEstandard("table", 100, true);
        updateComponentProgressEstandard("vehicles", 100, true);
      }
      return;
    }

    console.log(
      "[useEffect] Procesando recorridos:",
      paginadorRecorridos.datos.length
    );

    const processRecorridosData = async () => {
      try {
        updateComponentProgressEstandard("table", 10, false);
        // updateComponentProgress("estadias", 10, false);

        logRecorridoSnapshot("Snapshot inicial de paginadorRecorridos.datos", paginadorRecorridos.datos);

        // Procesar recorridos - añadir direcciones concatenadas
        const datosRecorridos = procesarRecorridos(paginadorRecorridos.datos);
        console.log("Después de procesarRecorridos:", datosRecorridos.length);

        logRecorridoSnapshot("Snapshot tras procesarRecorridos", datosRecorridos);
        console.log("[EstadiasReport] Filtros activos para cálculo:", filters);

        updateComponentProgressEstandard("table", 30, false);
        // updateComponentProgress("estadias", 30, false);

        // Asignar velocidad máxima
        //const recorridosConVelocidad = asignarVelocidadMaxima(datosRecorridos);
        setRecorridos(datosRecorridos);

        updateComponentProgressEstandard("table", 50, false);
        // updateComponentProgress("estadias", 50, false);

        // Calcular estadías con múltiples tipos de vista
        const estadiasCalculadas = calcularEstadiasMultiples(
          datosRecorridos,
          filters
        );

        if (estadiasCalculadas?.estadias) {
          logRecorridoSnapshot("Snapshot de estadías generadas", estadiasCalculadas.estadias);
        }
        console.log("[index] Estadías calculadas:", estadiasCalculadas.estadias?.length || 0);

        // Verificar si tienen los campos esperados por los componentes
        if (estadiasCalculadas.estadias.length > 0) {
          const primerEstadia = estadiasCalculadas.estadias[0];
          console.log("[index] Campos críticos:", {
            tipo: primerEstadia.tipo,
            punto_inicio: primerEstadia.punto_inicio,
            tiempo_segundos: primerEstadia.tiempo_segundos,
          });
        }

        setEstadias(estadiasCalculadas.estadias);
        setDataEstadias(estadiasCalculadas.estadias);

        // Calcular resumen de unidad
        // const resumen = calcularResumenUnidad(
        //   recorridosConVelocidad,
        //   filters.fecha_inicio,
        //   filters.fecha_fin
        // );
        setResumenUnidad(estadiasCalculadas.resumen);

        updateComponentProgressEstandard("table", 100, true);
        updateComponentProgressEstandard("vehicles", 100, true);
        // updateComponentProgress("estadias", 70, false);

        // updateComponentProgress("estadias", 100, true);
        // updateComponentProgress("graficos", 100, true);
        // updateComponentProgress("ubicaciones", 100, true);
        // updateComponentProgress("resumen", 100, true);

        console.log("✅ Procesamiento de estadías completado");
      } catch (error) {
        console.error("Error al procesar recorridos:", error);
        updateComponentProgressEstandard("table", 100, true);
        // updateComponentProgress("estadias", 100, true);
        // updateComponentProgress("graficos", 100, true);
        // updateComponentProgress("ubicaciones", 100, true);
        // updateComponentProgress("resumen", 100, true);
      }
    };

    // ✅ USAR TIMEOUT PARA EVITAR BLOQUEO DE UI Y CICLOS
    const timeoutId = setTimeout(processRecorridosData, 500);

    return () => clearTimeout(timeoutId);
  }, [paginadorRecorridos.datos, paginadorRecorridos.cargando, filters]); // ✅ DEPENDENCIAS NECESARIAS

  // ✅ FUNCIÓN processData
  const processData = (data) => {
    console.log("[processData] Procesando datos:", data?.length || 0);

    if (!data || !Array.isArray(data) || data.length === 0) {
      console.warn("[processData] Datos inválidos o vacíos:", data);
      return [];
    }

    const groupedData = {};
    const _agrupado = groupBy(data, "punto_inicio");

    if (_agrupado != null) {
      for (const [key, value] of Object.entries(_agrupado)) {
        // Calcular tiempo total en segundos - validar que sean números
        const segundosTotales = value.reduce((total, valor) => {
          const segundos = parseInt(valor.tiempo_segundos) || 0;
          if (isNaN(segundos)) {
            console.warn(
              "[processData] Valor de tiempo_segundos inválido:",
              valor.tiempo_segundos
            );
            return total;
          }
          return total + segundos;
        }, 0);

        // Determinar categoría basándose en el primer elemento del grupo
        let categoria = "Indeterminado";
        if (value.length > 0) {
          const primerItem = value[0];
          categoria = primerItem.tipo || "indeterminado";

          // Capitalizar primera letra para consistencia
          categoria = categoria.charAt(0).toUpperCase() + categoria.slice(1);
        }

        groupedData[key] = {
          title: key,
          visits: value.length,
          hours: segundosATiempo(segundosTotales),
          segundos: segundosTotales,
          color: getGroupColor(key),
          category: categoria,
        };

        console.log(
          `[processData] Grupo ${key}: ${value.length} visitas, ${segundosTotales}s, categoría: ${categoria}`
        );
      }
    }

    const _ordenado = Object.fromEntries(
      Object.entries(groupedData).sort((a, b) => b[1].visits - a[1].visits)
    );

    const resultado = Object.values(_ordenado);
    console.log("[processData] Resultado final:", resultado.length);

    return resultado;
  };

  // ✅ EFECTO PARA ACTUALIZAR PROGRESO DE CARGA
  useEffect(() => {
    if (paginadorRecorridos.progresoCargado > 0) {
      const progress = paginadorRecorridos.progresoCargado;

      setTotalCarga([
        {
          title: "Total de reporte cargado",
          percent: progress,
          color: "#2770e9",
          animated: true,
        },
      ]);

      updateDebugMetricsEstandard({
        connectionId: "recorridos-vehiculos",
        downloadProgress: progress,
      });
    }
  }, [paginadorRecorridos.progresoCargado, updateDebugMetricsEstandard]);

  // ✅ EFECTO PARA CONTROLAR ESTADO DE CARGA
  useEffect(() => {
    if (!searchInitiated) {
      setIsLoading(false);
      return;
    }

    const isDataLoading = paginadorRecorridos.cargando;
    const areComponentsLoading = Object.values(loadingComponentsEstandard).some(
      (c) => c.loading
    );

    if (isDataLoading || (areComponentsLoading && estadias.length === 0)) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    paginadorRecorridos.cargando,
    loadingComponentsEstandard,
    estadias.length,
    searchInitiated,
  ]);

  // ✅ EFECTO DE LIMPIEZA AL DESMONTAR
  useEffect(() => {
    return () => {
      console.log("🧹 Limpieza al desmontar componente de estadías");

      if (safetyTimeoutRef.current) {
        clearTimeout(safetyTimeoutRef.current);
        safetyTimeoutRef.current = null;
      }

      if (monitorIntervalRef.current) {
        clearInterval(monitorIntervalRef.current);
        monitorIntervalRef.current = null;
      }

      limpiarCache();
    };
  }, []);

  const MySwal = withReactContent(Swal);

  // FUNCIONES DE MANEJO DE EVENTOS
  const handleSelectAlertType = (alertType) => {
    setSelectedAlertType(alertType);
    setHighlightedAlertType(alertType);
  };

  // ✅ FUNCIONES PARA DETECTAR ESTADO VACÍO
  const shouldShowEmptyState = useCallback(() => {
    if (isLoading) return true;

    if (
      !filters ||
      !filters.uids_vehiculo ||
      filters.uids_vehiculo.length === 0
    ) {
      return true;
    }

    if (estadias.length === 0 && !paginadorRecorridos.cargando) {
      return true;
    }

    return false;
  }, [isLoading, filters, estadias.length, paginadorRecorridos.cargando]);

  const getEmptyStateProps = useCallback(() => {
    if (
      !filters ||
      !filters.uids_vehiculo ||
      filters.uids_vehiculo.length === 0) {
      return {
        component: <NoSelectionEmptyState reportType={'estadías'} entityType='estadías' />,
        show: true
      };
    }

    return {
      component: <NoDataEmptyState reportType={'estadías'} entityType='estadías' />,
      show: true
    };
  }, [filters]);

  const selectedVehiclesMap = useMemo(() => {
    const map = new Map();
    const fallback = Array.isArray(filters?.vehiculos_detalle)
      ? filters.vehiculos_detalle
      : [];
    const source = Array.isArray(selectedVehiclesDetail) && selectedVehiclesDetail.length > 0
      ? selectedVehiclesDetail
      : fallback;

    if (!Array.isArray(source)) {
      return map;
    }

    source.forEach((vehiculo) => {
      if (!vehiculo) {
        return;
      }

      const uid = vehiculo.uid_vehiculo || vehiculo.value;
      if (!uid) {
        return;
      }

      map.set(uid, vehiculo);
    });

    return map;
  }, [filters, selectedVehiclesDetail]);

  // ✅ Cadena de filtrado memoizada: solo se rebuilda cuando cambian datos, filtro o vehículos.
  // Antes se reconstruía en cada render del padre (provocando que MasterDetailTable corriera
  // su useEffect pesado y reencolara geocode en cada update del paginador/store).
  const filteredEstadias = useMemo(() => {
    const filtroAlerta = selectedAlertType ? selectedAlertType.toLowerCase() : null;
    const fuente = filtroAlerta
      ? estadias.filter((item) =>
          (item?.punto_inicio || '').toLowerCase().includes(filtroAlerta)
        )
      : estadias;

    const groupedData = fuente.reduce((acc, record) => {
      const key = record.uid_vehiculo;
      const vehiculoMeta = selectedVehiclesMap.get(key);

      if (!acc[key]) {
        acc[key] = {
          ...record,
          no_economico: vehiculoMeta?.no_economico ?? record.no_economico,
          alias: vehiculoMeta?.alias ?? record.alias,
          direccion: record.direccion || record.Direccion || record.address || '',
          children: [],
        };
      }

      acc[key].children.push({
        uid_vehiculo: record.uid_vehiculo,
        no_economico: vehiculoMeta?.no_economico ?? record.no_economico,
        alias: vehiculoMeta?.alias ?? record.alias,
        chofer:
          typeof record.chofer === "object"
            ? record.chofer?.nombreChofer || ""
            : record.chofer || "",
        fecha_inicio: record.fecha_inicio,
        fecha_fin: record.fecha_fin,
        punto_inicio: record.punto_inicio,
        punto_fin: record.punto_fin,
        tiempo: record.tiempo,
        tipo_reporte: record.tipo_reporte,
        latitud: record.latitud,
        longitud: record.longitud,
        tiempo_segundos: record.tiempo_segundos,
        evento: record.evento_inicio,
        tipo: record.tipo,
        tipo_real: record.tipo_real,
        alerta_real: record.alerta_real,
        direccion: record.direccion || record.Direccion || record.address || '',
      });

      return acc;
    }, {});

    return Object.values(groupedData).map((item) => {
      const vehiculoMeta = selectedVehiclesMap.get(item.uid_vehiculo);
      const alias = vehiculoMeta?.alias ?? item.alias ?? "";
      const noEconomico = vehiculoMeta?.no_economico ?? item.no_economico ?? "";
      const displayLabel = vehiculoMeta?.label || [noEconomico, alias].filter(Boolean).join(" / ");

      return {
        ...item,
        no_economico: displayLabel,
        alias,
        fecha_inicio: "",
        fecha_fin: "",
        chofer: "",
        punto_inicio: "",
        punto_fin: "",
        tiempo: "",
        ismaster: true,
      };
    });
  }, [estadias, selectedAlertType, selectedVehiclesMap]);

  const dataWithColors = useMemo(() => {
    if (!estadias || estadias.length === 0) {
      return [];
    }
    return processData(estadias);
  }, [estadias]);

  const processDataOriginal = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    const groupedData = {};
    const _agrupado = groupBy(data, "punto_inicio");

    if (_agrupado != null) {
      for (const [key, value] of Object.entries(_agrupado)) {
        const segundos = value.reduce(
          (total, valor) => total + (valor.tiempo_segundos || 0),
          0
        );

        groupedData[key] = {
          title: key,
          visits: value.length,
          hours: segundosATiempo(segundos),
          segundos: segundos,
          color: getGroupColor(key),
          category: value[0]?.tipo || "Indeterminado",
        };
      }
    }

    const _ordenado = Object.fromEntries(
      Object.entries(groupedData).sort((a, b) => b[1].visits - a[1].visits)
    );

    return Object.values(_ordenado);
  };

  useEffect(() => {
    if (!window.printReportModule) {
      window.printReportModule = new PrintReportModule({
        captureQuality: 0.95,
        pdfFormat: "A4",
        pdfOrientation: "landscape",
        useNativeTables: true,
        maxRowsPerPage: 30,
        tableFontSize: 7,
        // Pesos por columna: Chofer, Evento, Marcador, F.Inicio, F.Fin, Duración, Coordenadas, Ubicación
        // (El extractor de estadias ignora la columna de expand, son 8 columnas)
        tableColumnWeights: [0.9, 1.0, 1.1, 1.0, 1.0, 0.8, 1.3, 2.6],

        // ✅ CONFIGURACIÓN ESPECÍFICA PARA REPORTE DE ESTADÍAS
        reportType: "estadias",
        captureContainer: "#reporte-tiempos-content",

        tableExtractionConfig: {
          enabled: true,
          selector: "#tabla-estadias",
          title: "Listado de estadias",
          type: "html", // html, tanstack, dual-table
          headerSelector: "thead th, thead td",
          bodySelector: "tbody tr",
          cellSelector: "td",
          // ✅ Transformaciones opcionales
          cellTransforms: {
            'button[class*="btn"]': "Ver Mapa",
            ".fa-map-marker-alt": "Ver Ubicación",
          },
        },

        // 📊 ESTRATEGIA HORIZONTAL: Capturar por filas (recomendado para landscape)
        horizontalStrategy: "rows",
        horizontalRows: [
          {
            title: "Resumen y Gráfico de tiempos",
            selector: ".g-3:first-of-type", // Primera fila con las dos cards
            identifier: "kilometraje-fila-1",
            selectorMethod: "direct",
          },
        ],

        // 📱 ESTRATEGIA VERTICAL: Capturar targets individuales (para portrait)
        verticalStrategy: "targets",
        captureTargets: [
          {
            title: "Resumen de estadias",
            selector: "#card-estadias-ubicaciones",
            type: "card",
          },

          {
            title: "Resumen de estadias",
            selector: "#card-estadias-ubicaciones-frecuentes",
            type: "card",
          },
        ],
      });
    }

    return () => {
      if (window.printReportModule) {
        delete window.printReportModule;
      }
    };
  }, []);

  return (
    <div>
      <div className=" m-3 ">
        <Row>
          <Col md={10}>
            <h4 className="mt-2">Estadías</h4>
          </Col>
        </Row>
      </div>

      <Card className="p-3 mb-0 mt-3">
        <hr className="text-danger" />

        <Filtros
          onGenerateReport={handleGenerateReport}
          imprimir={
            shouldShowEmptyState() ? false : showFilters && estadias.length > 0
          }
        />

        {(paginadorRecorridos.cargando ||
          Object.values(loadingComponentsEstandard).some((c) => c.loading)) && (
            <Col md={12} className="mt-3">
              <ProgressBarWithComponents
                loadingComponents={loadingComponentsEstandard}
                calculateTotalProgress={calculateTotalProgressEstandard}
                debugMetrics={debugMetricsEstandard}
              />
            </Col>
          )}

        {errorMessage && (
          <div className="alert alert-danger mt-3" role="alert">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {errorMessage}
          </div>
        )}
      </Card>

      {/* <Card className="p-3 mb-3 mt-3">
        <div className="d-flex justify-content-between align-items-center mb-1 mt-3">
          <h4 className="mb-0">Reporte de estadias</h4>
          <div className="d-flex align-items-center gap-2">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setShowDebugPanel(!showDebugPanel)}
              title="Mostrar métricas de debug"
            >
              <i className="fas fa-bug"></i>
            </Button>
          </div>
        </div>

        <hr className="text-danger" />

       

        {showDebugPanel && (
          <Card className="mt-3 border-info">
            <Card.Header className="bg-info text-white">
              <h6 className="mb-0">
                <i className="fas fa-chart-line me-2"></i>
                Métricas de Rendimiento - Estadías
              </h6>
            </Card.Header>
            <Card.Body>
              <Row>
                <Col md={6}>
                  <h6>🔗 Conexiones:</h6>
                  {Object.entries(debugMetrics.connections).map(([id, conn]) => (
                    <div key={id} className="mb-2 p-2 border rounded">
                      <div className="d-flex justify-content-between">
                        <strong>{conn.name}</strong>
                        <span className={`badge ${
                          conn.status === 'completed' ? 'bg-success' :
                          conn.status === 'downloading' ? 'bg-warning' :
                          conn.status === 'failed' ? 'bg-danger' : 'bg-secondary'
                        }`}>
                          {conn.status}
                        </span>
                      </div>
                      <small className="text-muted">
                        Registros: {conn.totalRecordsReceived} / {conn.totalRecordsExpected} 
                        ({conn.downloadProgress?.toFixed(1)}%)
                      </small>
                    </div>
                  ))}
                </Col>
                <Col md={6}>
                  <h6>⏱️ Tiempos de Componentes:</h6>
                  {Object.entries(debugMetrics.componentTimes).map(([comp, times]) => (
                    <div key={comp} className="mb-1">
                      <small>
                        <strong>{comp}:</strong> 
                        {times.start && times.end ? 
                          ` ${((times.end - times.start) / 1000).toFixed(2)}s` : 
                          times.start ? ' En progreso...' : ' No iniciado'
                        }
                      </small>
                    </div>
                  ))}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        )}

        {(paginadorRecorridos.cargando || Object.values(loadingComponents).some(c => c.loading)) && (
          <Col md={12} className="mt-3">
            <ProgressBarWithComponents 
              loadingComponents={loadingComponents}
              calculateTotalProgress={calculateTotalProgress}
            />
          </Col>
        )}

        {errorMessage && (
          <div className="alert alert-danger mt-3" role="alert">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {errorMessage}
          </div>
        )}
      </Card> */}

      {!searchInitiated ? (
        <WelcomeEmptyState reportType="estadías" />
      ) : isLoading ? (
        <LoadingEmptyState reportType="estadías" />
      ) : shouldShowEmptyState() ? (
        getEmptyStateProps().component
      ) : (
        <>
          {showFilters && estadias.length > 0 && (
            <>
              <div id="reporte-estadias-content" className="mb-3">
                <Row className="g-3 mt-1">
                  <Col md={6}>
                    <div style={{ height: "253px" }}>
                      <EstadiasTotal
                        data={estadias}
                        radius={["100%", "87%"]}
                        resumenUnidad={resumenUnidad} // ✅ PASAR EL RESUMEN
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      id="card-estadias-ubicaciones"
                      style={{ height: "253px" }}
                    >
                      <EstadiasTiempoUbi
                        data={dataWithColors}
                        className="h-md-100"
                        estadias={estadias} // ✅ PASAR LAS ESTADÍAS TAMBIÉN
                      />
                    </div>
                    {/* <EstadiasTiempoUbi
                      data={dataWithColors}
                      className="h-100"
                    /> */}
                  </Col>

                  <Col md={12}>
                    <div id="card-estadias-ubicaciones-frecuentes">
                      <EstadiasUbicacionesFrec
                        data={dataWithColors}
                        onSelectAlertType={handleSelectAlertType}
                        highlightedAlertType={highlightedAlertType}
                        handleCleanFilters={handleClearFilters}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col md={12} xs={12}>
                    <div id="tabla-estadias">
                      <MasterDetailTable
                        data={filteredEstadias}
                        geocercas={geocercas}
                        referencias={referencias || []}
                        clientes={clientes || []}
                        title={"Listado Estadias"}
                        isGroup={true}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

// import React, { useEffect, useState, useRef } from "react";
// import { Card, Col, Row, Spinner, Button, ProgressBar } from "react-bootstrap";
// import Filtros from "./components/Filtros";
// import { ReporteEstadiaService } from "../../../services/apiService";
// import MasterDetailTable from "./components/estadias-lista-quro/MasterDetailTable";
// import EstadiasUbicacionesFrec from "./components/estadias-ubicaciones-frecuentes/EstadiasUbicacionesFrec";
// import EstadiasTiempoUbi from "./components/estadias-tiempo-ubicaciones/EstadiasTiempoUbi";
// import EstadiasTotal from "./components/estadias-total/EstadiasTotal";
// import Swal from 'sweetalert2';
// import { toast } from "react-toastify";
// import withReactContent from 'sweetalert2-react-content';
// import { groupBy, sortBy } from "underscore";
// import { segundosATiempo } from "../../../helpers/utils";
// import { useEstadiasStore } from "../../../lib/store/estadias.store";
// import { paginadoRecorridosStore } from "../../../lib/store/paginador_store";
// import { asignarVelocidadMaxima, calcularEstadiasMultiples, calcularResumenUnidad, procesarRecorridos } from "../../../utils/useReporteCalculations";
// import cargarPaginas from "../../../providers/provider_paginado";
// import classNames from 'classnames';

// export default function EstadiasReport() {
//   const paginadorRecorridos = paginadoRecorridosStore();
//   const [recorridos, setRecorridos] = useState([]);
//   const [totalCarga, setTotalCarga] = useState([]);
//   const [showFilters, setShowFilters] = useState(false);
//   const [estadias, setEstadias] = useState([]);
//   const [resumenUnidad, setResumenUnidad] = useState([]);
//   const [isLoading, setIsLoading] = useState(false); // Estado para controlar el spinner
//   const [filters, setFilters] = useState({
//     fecha_inicio: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
//     fecha_fin: new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
//     uids_vehiculos: [],
//     tipo_vista: 0,
//     tipo_reporte: 0,
//     tiempo_estancia: 0,
//     distancia_estancia: 0,//estaticos
//     encendido_o_apagado: "Todo" //estaticos
//   });

//   // declaramos el store de estadias
//   const setDataEstadias = useEstadiasStore((state) => state.setDataEstadias)
//   const setFiltroEstadiaTiempo = useEstadiasStore((state) => state.setFiltroEstadiaTiempo)
//   const setFiltroEstadiaUbicacion = useEstadiasStore((state) => state.setFiltroEstadiaUbicacion)

//   // 🚀 NUEVOS ESTADOS para resaltar
//   const [highlightedAlertType, setHighlightedAlertType] = useState(null);

//   // 📌 NUEVOS ESTADOS PARA FILTRADO DINÁMICO
//   const [selectedAlertType, setSelectedAlertType] = useState(null);

//   const handleGenerateReport = (selectedFilters) => {
//     paginadorRecorridos.editarProgresoCargado(0);
//     setTotalCarga([]);
//     setFilters(selectedFilters);
//     setShowFilters(true);
//     setEstadias([]);
//   };

//   // Mapas para asignar colores a cada grupo
//   const groupColorsRef = useRef(new Map());
//   const usedColors = new Set();

//   const getUniqueColor = () => {
//     let newColor;
//     do {
//       newColor = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
//     } while (usedColors.has(newColor));
//     usedColors.add(newColor);
//     return newColor;
//   };

//   const getGroupColor = (groupName) => {
//     if (!groupColorsRef.current.has(groupName)) {
//       const newColor = getUniqueColor();
//       groupColorsRef.current.set(groupName, newColor);
//     }
//     return groupColorsRef.current.get(groupName);
//   };

//   const generarFiltro = (filtro) => {
//     const decoded = jwtDecode(localStorage.getItem('token'));
//     return {
//       fecha_inicio: filtro.fecha_inicio,
//       fecha_fin: filtro.fecha_fin,
//       ids_tipo_alerta: filtro.ids_tipo_alerta,
//       uids_vehiculo: filtro.uids_vehiculo,
//       empresaUid: decoded.uid_empresa,
//       page: 1,
//       limit: 10000,
//       uid_usuario: decoded.uid_usuario,
//       perfil: 1,
//       count: true,
//     };
//   };

//   useEffect(() => {
//     const loadEstadiasReport = async (filtros) => {
//       handleClearFilters();
//       setIsLoading(true); // Activar el spinner antes de la petición
//       try {
//         if (filtros.uids_vehiculos.length > 0) {

//           if (paginadorRecorridos.cargando === false && filtros !== null &&
//             (filtros.uids_vehiculo?.length > 0 || filtros.uids_vehiculos?.length > 0)) {

//             // Asegurar que el formato es correcto
//             const filtrosFormateados = {
//               ...filtros,
//               // Si existe uids_vehiculos pero no uids_vehiculo, copiar el valor
//               uids_vehiculo: filtros.uids_vehiculo || filtros.uids_vehiculos
//             };

//             cargarPaginas(`${process.env.REACT_APP_ALERTS_API_URL}/vehicle-locations`, paginadorRecorridos, filtrosFormateados);
//           }
//           /*  const response = await ReporteEstadiaService.getReporteEstadia(filtros);
//             if (response && response.statusCode === 200) {

//               setEstadias(response.data);
//               setDataEstadias(response.data)

//               if (response.data.length <= 0) {
//                 MySwal.fire({
//                   icon: 'error',
//                   text: 'No se encontraron registros para la consulta',
//                   showConfirmButton: true
//                 })
//               }
//             } else {
//               toast.error(response?.message || "Error al generar reporte");
//             }
//           */
//         }
//       } catch (error) {
//         console.error("Error al cargar reporte estadias:", error);
//       } finally {
//         setIsLoading(false); // Desactivar el spinner después de la petición
//       }
//     };
//     loadEstadiasReport(filters);
//   }, [filters]);

//   useEffect(() => {
//     if (paginadorRecorridos.datos && paginadorRecorridos.datos.length > 0) {
//       console.log("Datos originales:", paginadorRecorridos.datos[0]);
//       // Procesar recorridos - añadir direcciones concatenadas
//       const datosRecorridos = procesarRecorridos(paginadorRecorridos.datos);
//       console.log("Después de procesarRecorridos:", datosRecorridos[0]);
//       // Asignar velocidad máxima (si tienes parametrosConfig)
//       // Si no tienes parametrosConfig disponible, puedes omitir esta línea
//       // const recorridosConVelocidad = asignarVelocidadMaxima(datosRecorridos, parametrosConfig);
//       const recorridosConVelocidad = asignarVelocidadMaxima(datosRecorridos);

//       setRecorridos(datosRecorridos);

//       // Calcular resumen de unidad
//       const resumen = calcularResumenUnidad(
//         recorridosConVelocidad,//datosRecorridos,
//         filters.fecha_inicio,
//         filters.fecha_fin
//       );
//       setResumenUnidad(resumen);

//       // Calcular estadías con múltiples tipos de vista
//       const estadiasCalculadas = calcularEstadiasMultiples(datosRecorridos, filters);
//       console.log("[index] Estadías calculadas:", estadiasCalculadas);

//       // Verificar si tienen los campos esperados por los componentes
//       if (estadiasCalculadas.length > 0) {
//         const primerEstadia = estadiasCalculadas[0];
//         console.log("[index] Campos críticos:", {
//           tipo: primerEstadia.tipo,
//           punto_inicio: primerEstadia.punto_inicio,
//           tiempo_segundos: primerEstadia.tiempo_segundos
//         });
//       }

//       setEstadias(estadiasCalculadas);

//       setIsLoading(false);
//     }
//   }, [paginadorRecorridos.datos]);

//   useEffect(() => {
//     if (paginadorRecorridos.progresoCargado > 0) {
//       setTotalCarga([
//         {
//           title: 'Total de reporte cargado',
//           percent: paginadorRecorridos.progresoCargado,
//           color: "#2770e9",
//           animated: true
//         }
//       ]);
//     }
//   }, [paginadorRecorridos.progresoCargado]);

//   const MySwal = withReactContent(Swal);

//   // 📌 Método para seleccionar un TIPO DE ALERTA en la gráfica "Estadias por ubicacion"
//   const handleSelectAlertType = (alertType) => {
//     setSelectedAlertType(alertType);
//     setHighlightedAlertType(alertType);
//   };

//   // 📌 Método para limpiar todos los filtros
//   const handleClearFilters = () => {
//     setSelectedAlertType(null);
//     setHighlightedAlertType(null);

//     setFiltroEstadiaTiempo({})
//     setFiltroEstadiaUbicacion({})
//   };

//   // 📌 Agrupar datos por `vehiculos.vehiculoUid` para el listado
//   let groupedData = estadias.reduce((acc, record) => {
//     const key = record.uid_vehiculo;

//     if (!acc[key]) {
//       acc[key] = {
//         ...record,
//         children: []
//       };
//     }

//     let description = "";

//     // Se agregan geocercas si existen y no son "0"
//     /*if (record.geocercas?.geocercasasignadas?.length > 0) {
//       const geocercas = record.geocercas.geocercasasignadas
//         .filter(g => g.geocercaUid !== "0")
//         .map(g => g.nombreGeocerca)
//         .join(', ');

//       if (geocercas) description += `${geocercas}`;
//     }

//     // Se agregan clientes si existen y no son "0"
//     if (record.clientes?.length > 0) {
//       const clientes = record.clientes
//         .filter(c => c.num_Tienda !== 0)
//         .map(c => c.nombreclientes)
//         .join(', ');

//       if (clientes) description += `${clientes}`;
//     }

//     // Se agregan referencias
//     if (record.referencias?.length > 0) {
//       const referencias = record.referencias
//         .filter(ref => ref.ReferenciaUid && ref.ReferenciaUid !== "0")
//         .map(c => c.nombreReferencia)
//         .join(', ');
//       if (referencias) description += `${referencias}`;
//     }*/

//     /*acc[key].children.push({
//       fecha: record.fecha,
//       chofer: record.chofer,
//       nombreEvento: record.nombreEvento,
//       distancia: record.distancia,
//       velocidad: record.velocidad,
//       combustible: record.obd?.combustibleAlerta || 'N/A',
//       direccion: description || 'Indeterminado',
//       latitud: record.latitud,
//       longitud: record.longitud,
//       noEconomico: ""
//     });*/

//     acc[key].children.push({
//       uid_vehiculo: record.uid_vehiculo,
//       no_economico: record.no_economico,
//       alias: record.alias,
//       chofer: record.chofer,
//       fecha_inicio: record.fecha_inicio,
//       fecha_fin: record.fecha_fin,
//       punto_inicio: record.punto_inicio,
//       punto_fin: record.punto_fin,
//       tiempo: record.tiempo,
//       tipo_reporte: record.tipo_reporte,
//       latitud: record.latitud,
//       longitud: record.longitud,
//       tiempo_segundos: record.tiempo_segundos,
//       evento: record.evento_inicio,
//     });

//     return acc;
//   }, {});

//   /*const formattedData = Object.values(groupedData).map((item, index) => ({
//     ...item, fecha: '', chofer: '', noEconomico: item.vehiculos.noEconomico, nombreEvento: '', distancia: '', velocidad: '', direccion: "", ismaster: true
//   }));*/

//   const formattedData = Object.values(groupedData).map((item, index) => ({
//     ...item, no_economico: `${item.alias} (${item.no_economico})`, fecha_inicio: '', fecha_fin: '', chofer: '', punto_inicio: '', punto_fin: '', tiempo: '', ismaster: true
//   }));

//   // 📌 Agrupar datos por clientes, geocercas y referencias con colores para grafica de ubicaciones frecuentes
//   const processData = (data) => {
//     const groupedData = {};

//     const _agrupado = groupBy(data, 'punto_inicio');

//     if (_agrupado != null) {

//       for (const [key, value] of Object.entries(_agrupado)) {

//         const segundos = value.reduce((total, valor) => total + valor.tiempo_segundos, 0)

//         groupedData[key] = {
//           title: key,
//           visits: value.length,
//           hours: segundosATiempo(segundos),
//           segundos: segundos,
//           color: getGroupColor(key),
//           category: value[0].tipo
//         };
//       }
//     }

//     const _ordenado = Object.fromEntries(
//       Object.entries(groupedData).sort((a, b) => a[1].visits - b[1].visits).reverse()
//     )

//     data.forEach(entry => {
//       // 📌 Calcular tiempo en horas basado en distancia y velocidad
//       /*let tiempoHoras = (entry.velocidad > 0) ? (entry.distancia / entry.velocidad) : 0;
//       let isGrouped = false; // Para saber si ya se asignó a una categoría

//       // 📌 Agrupar por geocercas
//       if (entry.geocercas && entry.geocercas.geocercasasignadas) {
//         entry.geocercas.geocercasasignadas.forEach(geo => {
//           if (geo.geocercaUid !== "0") {
//             if (!groupedData[geo.nombreGeocerca]) {
//               groupedData[geo.nombreGeocerca] = {
//                 title: geo.nombreGeocerca,
//                 visits: 0,
//                 hours: 0,
//                 color: getGroupColor(geo.nombreGeocerca),
//                 category: "Geocercas"
//               };
//             }
//             groupedData[geo.nombreGeocerca].visits += 1;
//             groupedData[geo.nombreGeocerca].hours += tiempoHoras;
//             isGrouped = true;
//           }
//         });
//       }

//       // 📌 Agrupar por clientes
//       if (entry.clientes) {
//         entry.clientes.forEach(cliente => {
//           if (cliente.num_Tienda !== 0) {
//             if (!groupedData[cliente.nombreclientes]) {
//               groupedData[cliente.nombreclientes] = {
//                 title: cliente.nombreclientes,
//                 visits: 0,
//                 hours: 0,
//                 color: getGroupColor(cliente.nombreclientes),
//                 category: "Clientes"
//               };
//             }
//             groupedData[cliente.nombreclientes].visits += 1;
//             groupedData[cliente.nombreclientes].hours += tiempoHoras;
//             isGrouped = true;
//           }
//         });
//       }

//       // 📌 Agrupar por referencias (con condición `ReferenciaUid !== "0"`)
//       if (entry.referencias) {
//         entry.referencias.forEach(ref => {
//           if (ref.ReferenciaUid !== "0") {  // 📌 Filtrar referencias válidas
//             if (!groupedData[ref.nombreReferencia]) {
//               groupedData[ref.nombreReferencia] = {
//                 title: ref.nombreReferencia,
//                 visits: 0,
//                 hours: 0,
//                 color: getGroupColor(ref.nombreReferencia),
//                 category: "Referencias"
//               };
//             }
//             groupedData[ref.nombreReferencia].visits += 1;
//             groupedData[ref.nombreReferencia].hours += tiempoHoras;
//             isGrouped = true;
//           }
//         });
//       }
//       // 📌 Si no pertenece a ninguna categoría, agrupar en "Indeterminado"
//       if (!isGrouped) {
//         if (!groupedData["Indeterminado"]) {
//           groupedData["Indeterminado"] = {
//             title: "Indeterminado",
//             visits: 0,
//             hours: 0,
//             color: getGroupColor("Indeterminado"),
//             category: "Indeterminado"
//           };
//         }
//         groupedData["Indeterminado"].visits += 1;
//         groupedData["Indeterminado"].hours += tiempoHoras;
//       }*/
//     });

//     return Object.values(_ordenado).map(group => ({
//       ...group,
//       //hours: parseFloat(group.hours.toFixed(2)) // Redondear a 2 decimales
//     }));
//   };

//   const dataWithColors = processData(estadias);

//   // 📌 Aplicar los filtros según la selección  alerta
//   let filteredEstadias = formattedData;

//   if (selectedAlertType) {
//     filteredEstadias = filteredEstadias.filter(filtered =>
//       filtered.children.some(child => child.punto_inicio === selectedAlertType)
//     );
//   }

//   return (
//     <div>
//       <Card className="p-3 mt-3">
//         {/* Titulo principal de la pagina */}
//         <div className="d-flex justify-content-between align-items-center">
//           <h4 className="mb-0">Reporte de estadias</h4>
//         </div>
//         {/* Subtitulo de la pagina */}
//         {/* <div className="d-flex justify-content-between align-items-center mt-3">
//           <p className="mb-0">Análisis de estadias</p>
//         </div> */}
//         <Filtros onGenerateReport={handleGenerateReport} />

//         {/* Indicador de progreso de carga */}
//         {paginadorRecorridos.cargando && (
//           <Col md={12}>
//             <Row>
//               <Col
//                 xs={6}
//                 sm="auto"
//                 className="pe-2 small py-2 d-flex align-items-center"
//                 key={'Generando reporte...'}
//               >
//                 <span
//                   className="dot"
//                   style={{ backgroundColor: "#2770e9", width: 10, height: 10, borderRadius: '50%', display: 'inline-block', marginRight: 5 }}
//                 ></span>
//                 <span>Generando reporte...</span>
//                 <span className="ms-1">({`${(totalCarga.length > 0 ? totalCarga[0].percent : 0).toFixed(0)}%`})</span>
//               </Col>
//             </Row>
//             <ProgressBar
//               style={{ height: 10 }}
//               className="shadow-none rounded-4 mb-3"
//             >
//               {totalCarga.map((item) => (
//                 <ProgressBar
//                   style={{ backgroundColor: item.color }}
//                   now={item.percent}
//                   key={item.title}
//                   animated={item.animated}
//                   className={classNames('overflow-visible position-relative rounded-pill')}
//                 />
//               ))}
//             </ProgressBar>
//           </Col>
//         )}
//       </Card>
//       {isLoading ? (
//         // 🌀 Mostrar Spinner de carga mientras la API responde
//         <div className="d-flex justify-content-center align-items-center my-5">
//           <Spinner animation="border" role="status" variant="primary" style={{ width: "3rem", height: "3rem" }}>
//             <span className="visually-hidden">Cargando...</span>
//           </Spinner>
//         </div>
//       ) : (
//         <>
//           {showFilters && estadias.length > 0 && (
//             <>
//               {/* Seccion de las graficas del reporte */}
//               <Row className="g-3 mt-1">
//                 <Col md={6}>
//                   <EstadiasTotal
//                     data={estadias}
//                     radius={['100%', '87%']}
//                   />
//                 </Col>
//                 <Col md={6}>
//                   <EstadiasTiempoUbi
//                     data={dataWithColors}
//                     className="h-100"
//                   />
//                 </Col>
//                 <Col md={12}>
//                   <EstadiasUbicacionesFrec
//                     data={dataWithColors}
//                     onSelectAlertType={handleSelectAlertType}
//                     highlightedAlertType={highlightedAlertType}
//                   />
//                 </Col>
//               </Row>
//               <Col md={12} className="d-flex justify-content-end mt-3">
//                 {/* 🔹 Botón para limpiar agrupaciones */}
//                 <Button variant="primary" onClick={handleClearFilters}>
//                   Limpiar Filtros
//                 </Button>
//               </Col>
//               {/* Lista del resultado del filtro */}
//               <Row className="mt-3">
//                 <Col md={12} xs={12}>
//                   <MasterDetailTable
//                     data={filteredEstadias}
//                     title={"Listado Estadias"}
//                     isGroup={true}
//                   />
//                 </Col>
//               </Row>
//             </>
//           )}
//         </>
//       )}
//     </div>
//   );
// }
